import React from 'react';
import PropTypes from 'prop-types';

// Components
import Badge from "components/Badge";

VariationCount.propTypes = {
    count: PropTypes.number.isRequired
};

function VariationCount({count, maxCount, maxAchieveColor = 'online', ...props}) {
    if (count <= 0 && !maxCount) {
        return null;
    }

    function badgeColor() {
        if (maxCount) {
            if (count > 0 && count < maxCount) {
                return 'warning';
            }

            if (count >= maxCount) {
                return maxAchieveColor;
            }
        }

        return 'info';
    }

    return (
        <Badge
            color={badgeColor()}
            rounded
            isBold={false}
            size={"large"}
        >
            {count}{maxCount ? `/${maxCount}` : ''}
        </Badge>
    );
}

export default VariationCount;
